import React, { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";
import { useCorretorParceiro } from "services/api/Identity_Usuario/listar-especialistas-produto";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import warn from "../../../../constants/toast";
import MaterialUI from "../../../../material-UI";
import axiosLead from "../../../../services/lead";
import { useListarEmpreendimentosAdmin } from "../../../../services/api/Admin_Empreendimentos/empreendimentos";
import { useListarEmpreendimentos2 } from "../../../../services/api/AppWeb_Empreendimento2/empreendimentos2";
import { useListarProfissoes } from "../../../../services/api/DadosComum/profissoes";
import { useMotivosAtendimento } from "../../../../services/api/AppWeb_Lead/motivos";
import { useListarObjetivosCompras } from "../../../../services/api/Mobile_ObjetivosCompras/objetivos-compras";
import { useTemperaturasLead } from "../../../../services/api/Mobile_Temperatura_Lead/temperaturas-lead";
import { useListarUsuariosCorretores } from "../../../../services/api/Identity_Usuario/listar-usuarios-corretores";
import * as SVGIcons from "../../../../assets/iconsSVG";
import { AuthState } from "../../../../store/ducks/auth/types";
import { CustomOption } from "../../../customOption";
import { FlagLeadAtt } from "../../../flagLeadAtt";
import UploadButton from "../../../UploadButton";
import Divider from "../../../Divider";
import * as Styles from "../../styles";
import * as IC from "./components";

interface Props {
  idLead?: string;
  nomeLead?: string;
  idLeadCorretor: string;
  itemConclude: any;
  onClose: Function;
  open: boolean;
  hotRefreshFunc: () => void;
  produto: string;
}

interface ConcludeTask {
  idLead: string;
  idLeadCorretor: string;
  idTipoTarefa: string;
  idEmpreendimento: string;
  titulo: string;
  observacao: string;
  descricao: any;
  observacoes: any;
  file: any;
  dataProgramadaRealizacaoTarefa: Date;
  horaProgramadaRealizacaoTarefa: Date;
  empreendimento: string;
  inserirTarefaNoOutlook: boolean;
  tokenAd: string;
  idTarefaLead: string;
  idTipoResultadoTarefa: any;
  anexo: any;
  // Sul fields
  motivoVisita: string | null;
  especialistaAcompanhou: string | null;
  objetivoCompra: string | null;
  profissao: string | null;
  bairroResidencial: string | null;
  idade: string | null;
  temperatura: string | null;
  codigoTipoAgendamentoVisita: number;
  localRegionalSul: any;
  solicitarPresencaEspecialista: boolean;
}

const ConcludeTaskForm: React.FC<Props> = ({
  idLead,
  nomeLead,
  idLeadCorretor,
  itemConclude,
  onClose,
  open,
  hotRefreshFunc,
  produto,
}) => {
  const { codigoRegional365 } = useSelector<any, AuthState>(
    (state) => state.user
  );
  const isSul = codigoRegional365 === "2";
  const { data: dataEmpreendimentoSul, refetch: refetchEmpreendimentosSul } =
    useListarEmpreendimentosAdmin();
  const { data: dataEmpreendimento2, refetch: refetchEmpreedimentos2 } =
    useListarEmpreendimentos2();
  const { data: dataProfissoes, refetch: refetchProfissoes } =
    useListarProfissoes();

  // Definindo tipoVisitaRetorno antes de seu uso
  const [tipoVisitaRetorno, setTipoVisitaRetorno] = useState(1);

  // Hooks para obter os dados de dropdown
  const { data: dataMotivosAtendimento, refetch: refetchMotivosAtendimento } =
    useMotivosAtendimento({
      tipoDeAtendimento: tipoVisitaRetorno,
      queryKey: "motivos_tipo_atendimento_tarefas",
    });
  const { data: dataObjetivosCompra, refetch: refetchObjetivosCompras } =
    useListarObjetivosCompras();
  const { data: dataTemperaturasLead, refetch: refetchTemperaturasLead } =
    useTemperaturasLead();

  const { data: dataCorretorParceiro, refetch: refetchCorretorParceiro } =
    useCorretorParceiro({
      queryKey: "corretor_parceiro",
    });

  const [conclusaoTarefasData, setConclusaoTarefasData] = useState([]);
  const [concludeSelected, setConcludeSelected] = useState({
    nome: itemConclude.tipoTarefa,
    id: itemConclude.idTipoTarefa,
  });
  const [datatask, setDataTask] = useState<Partial<ConcludeTask>>({
    inserirTarefaNoOutlook: false,
    dataProgramadaRealizacaoTarefa: new Date(),
    horaProgramadaRealizacaoTarefa: new Date(),
    idLead,
    idLeadCorretor,
    idTipoTarefa: itemConclude.idTipoTarefa,
    titulo: itemConclude.titulo,
    idTarefaLead: itemConclude.idTarefaLead,
    idTipoResultadoTarefa: concludeSelected?.id,
    observacoes: "",
    descricao: "",
    // Sul fields
    motivoVisita: "",
    especialistaAcompanhou: "",
    objetivoCompra: "",
    profissao: "",
    bairroResidencial: "",
    idade: "",
    temperatura: "",
    codigoTipoAgendamentoVisita: 1,
    localRegionalSul: null,
    solicitarPresencaEspecialista: false,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [solicitarPresencaEspecialista, setSolicitarPresencaEspecialista] =
    useState(false);
  const [localSul, setLocalSul] = useState<any>(null);
  const [isFutureDate, setIsFutureDate] = useState<boolean>(false);

  // const { username } = useSelector<RootStateOrAny, UserState>(
  //   (state) => state.user
  // );

  // useEffect(() => {
  //   requestToken();
  // }, [datatask?.inserirTarefaNoOutlook]);

  // const requestToken = async () => {
  //   const tokenStorage = await refreshTokenAzure(username);
  //   setTokenAD(tokenStorage);
  // };
  const [tokenAD] = useState<any>("");

  // Manipuladores para os campos do SUL
  const handleMotivoVisitaChange = (value: string) => {
    setDataTask({
      ...datatask,
      motivoVisita: value,
    });
  };

  const handleEspecialistaChange = (value: string) => {
    setDataTask({
      ...datatask,
      especialistaAcompanhou: value,
    });
  };

  const handleObjetivoCompraChange = (value: string) => {
    setDataTask({
      ...datatask,
      objetivoCompra: value,
    });
  };

  const handleProfissaoChange = (value: string) => {
    setDataTask({
      ...datatask,
      profissao: value,
    });
  };

  const handleBairroResidencialChange = (value: string) => {
    setDataTask({
      ...datatask,
      bairroResidencial: value,
    });
  };

  const handleIdadeChange = (value: string) => {
    setDataTask({
      ...datatask,
      idade: value,
    });
  };

  const handleTemperaturaChange = (value: string) => {
    setDataTask({
      ...datatask,
      temperatura: value,
    });
  };

  // Objetos para dropdowns
  const [motivoAtendimento, setMotivoAtendimento] = useState<any>(null);
  const [objetivoCompra, setObjetivoCompra] = useState<any>(null);
  const [temperatura, setTemperatura] = useState<any>(null);
  const [profissaoSelecionada, setProfissaoSelecionada] = useState<any>(null);
  const [corretorParceiro, setCorretorParceiro] = useState<any>(null);

  // Verifica se a data é futura
  useEffect(() => {
    if (datatask.dataProgramadaRealizacaoTarefa) {
      const currentDate = new Date();
      const selectedDate = new Date(datatask.dataProgramadaRealizacaoTarefa);

      // Remove time part for comparison
      currentDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      setIsFutureDate(selectedDate > currentDate);
    }
  }, [datatask.dataProgramadaRealizacaoTarefa]);

  const handleTransferComment = (comment: any) => {
    setDataTask({
      ...datatask,
      observacoes: comment,
      idTipoResultadoTarefa: concludeSelected?.id,
    });
  };

  const handleTransferFile = (newValue: any) => {
    setDataTask({
      ...datatask,
      anexo: { nome: newValue, anexoBase64: newValue },
      idTipoResultadoTarefa: concludeSelected?.id,
    });
  };

  const handleTransferDescription = (description: any) => {
    setDataTask({
      ...datatask,
      descricao: description,
      idTipoResultadoTarefa: concludeSelected?.id,
    });
  };

  const handleChangeData = (newValue: any) => {
    setDataTask({ ...datatask, dataProgramadaRealizacaoTarefa: newValue });
  };

  const handleChangeHora = (newValue: any) => {
    setDataTask({ ...datatask, horaProgramadaRealizacaoTarefa: newValue });
  };

  const [desqualificarIdData, setDesqualificarIdData] = useState<any>();

  const [file, setFile] = useState<any>();
  const [fileData, setFileData] = useState<any>();

  const [empreendimentoSelected, setEmpreendimentoSelected] = useState({
    bandeira: "",
    label: "",
    value: "",
  });

  const pull_data = useCallback((data: any) => {
    setDesqualificarIdData(data);
  }, []);

  const pull_file = useCallback((fileData: any) => {
    setFile(fileData);
  }, []);

  const pull_file_based = useCallback((fileData: any) => {
    setFileData(fileData);
  }, []);

  const pull_data_empreendimento = useCallback((data: any) => {
    setEmpreendimentoSelected(data);
  }, []);

  const FormPersonalizado = () => {
    switch (concludeSelected?.nome) {
      case "Acompanhamento":
      case "Não Conseguiu Contato":
      case "Em Contato Com Outro Corretor":
        return (
          <>
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
          </>
        );
      case "Atendimento Realizado":
        return (
          <>
            {isSul ? (
              <>
                {/* Campos SUL */}
                <IC.DefaultForm
                  functionComment={(e: any) =>
                    handleTransferComment(e.target.value)
                  }
                  count={datatask.observacoes.length}
                  value={datatask.observacoes}
                  valueFile={pull_file}
                  valueFileBased={pull_file_based}
                  functionFile={(e: any) => handleTransferFile(e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    padding: "0 24px",
                  }}
                >
                  <Divider text="Sobre o atendimento" />
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        {tipoVisitaRetorno === 1
                          ? "Motivo da visita"
                          : "Motivo do retorno"}{" "}
                        <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        fullWidth
                        options={
                          dataMotivosAtendimento
                            ? dataMotivosAtendimento?.data?.motivos?.map(
                                (item: any) => ({
                                  id: item?.codigo,
                                  nome: item?.nome,
                                })
                              )
                            : []
                        }
                        value={motivoAtendimento}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Motivo da visita"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(event: any, newValue: any) => {
                          setMotivoAtendimento(newValue);
                          setDataTask({
                            ...datatask,
                            motivoVisita: newValue?.nome || "",
                          });
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>

                  <Styles.SpaceY space={8} />
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Especialista que acompanhou <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        defaultValue={{
                          nome: "Selecione um especialista",
                          id: "1",
                        }}
                        fullWidth
                        options={
                          dataCorretorParceiro
                            ? dataCorretorParceiro?.data?.map((item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={corretorParceiro}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Especialista"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(event: any, newValue: any) => {
                          setCorretorParceiro(newValue);
                          setDataTask({
                            ...datatask,
                            especialistaAcompanhou: newValue?.nome || "",
                          });
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Objetivo de compra <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        defaultValue={{
                          nome: "Selecione um objetivo de compra",
                          id: "1",
                        }}
                        fullWidth
                        options={
                          dataObjetivosCompra
                            ? dataObjetivosCompra?.data?.map((item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={objetivoCompra}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Objetivo de compra"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(event: any, newValue: any) => {
                          setObjetivoCompra(newValue);
                          setDataTask({
                            ...datatask,
                            objetivoCompra: newValue?.nome || "",
                          });
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                  <Divider text="Sobre o cliente" />
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Profissão<p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        defaultValue={{
                          nome: "Selecione uma profissão",
                          id: "1",
                        }}
                        fullWidth
                        options={
                          dataProfissoes
                            ? dataProfissoes?.data?.map((item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={profissaoSelecionada}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Profissão"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(event: any, newValue: any) => {
                          setProfissaoSelecionada(newValue);
                          setDataTask({
                            ...datatask,
                            profissao: newValue?.nome || "",
                          });
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Bairro residencial <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        variant="outlined"
                        fullWidth
                        required
                        value={datatask.bairroResidencial}
                        onChange={(e) =>
                          handleBairroResidencialChange(e.target.value)
                        }
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Idade <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        variant="outlined"
                        fullWidth
                        required
                        value={datatask.idade}
                        onChange={(e) => {
                          // Remove caracteres não numéricos
                          const value = e.target.value.replace(/\D/g, "");
                          // Garante que o valor tenha no máximo 3 dígitos
                          const idadeValue = value.slice(0, 3);
                          // Garante que o valor esteja no intervalo [0, 130]
                          const idadeNumerico = parseInt(idadeValue, 10);
                          const idadeFinal = Number.isNaN(idadeNumerico)
                            ? ""
                            : Math.min(idadeNumerico, 130).toString();
                          // Atualiza o estado
                          handleIdadeChange(idadeFinal);
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>Temperatura</Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        fullWidth
                        options={
                          dataTemperaturasLead
                            ? dataTemperaturasLead?.data?.map((item: any) => ({
                                id: item?.idSistemaOrigem ?? item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={temperatura}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Temperatura"
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(event: any, newValue: any) => {
                          setTemperatura(newValue);
                          setDataTask({
                            ...datatask,
                            temperatura: newValue?.nome || "",
                          });
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                </div>
              </>
            ) : (
              <>
                <IC.DefaultForm
                  functionComment={(e: any) =>
                    handleTransferComment(e.target.value)
                  }
                  count={datatask.observacoes.length}
                  value={datatask.observacoes}
                  valueFile={pull_file}
                  valueFileBased={pull_file_based}
                  functionFile={(e: any) => handleTransferFile(e.target.value)}
                />
              </>
            )}
          </>
        );
      case "Atendimento Não Realizado":
        return (
          <>
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
          </>
        );
      case "Retornar Contato":
      case "Precisa Vender Imóvel":
        return (
          <>
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
            <IC.NovaTarefaForm
              dataProgramadaValue={datatask.dataProgramadaRealizacaoTarefa}
              functionDataChange={(newValue: any) => handleChangeData(newValue)}
              horaProgramadaValue={datatask.horaProgramadaRealizacaoTarefa}
              functionHoraChange={(newValue: any) => handleChangeHora(newValue)}
              functionDescricaoChange={(e: any) =>
                handleTransferDescription(e.target.value)
              }
              descricaoValue={datatask.descricao}
              count={datatask.descricao?.length || 0}
              checkValue={datatask.inserirTarefaNoOutlook}
              functionCheckChange={() =>
                setDataTask({
                  ...datatask,
                  inserirTarefaNoOutlook: !datatask.inserirTarefaNoOutlook,
                })
              }
              produtoInputSetado={false}
              produtoInput={false}
              empreendimentoSelectedValue={pull_data_empreendimento}
            />
          </>
        );
      case "Remarcou":
        return (
          <>
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
            <IC.NovaTarefaForm
              dataProgramadaValue={datatask.dataProgramadaRealizacaoTarefa}
              functionDataChange={(newValue: any) => handleChangeData(newValue)}
              horaProgramadaValue={datatask.horaProgramadaRealizacaoTarefa}
              functionHoraChange={(newValue: any) => handleChangeHora(newValue)}
              functionDescricaoChange={(e: any) =>
                handleTransferDescription(e.target.value)
              }
              descricaoValue={datatask.descricao}
              count={datatask.descricao?.length || 0}
              checkValue={datatask.inserirTarefaNoOutlook}
              functionCheckChange={() =>
                setDataTask({
                  ...datatask,
                  inserirTarefaNoOutlook: !datatask.inserirTarefaNoOutlook,
                })
              }
              produtoInput={false}
              produtoInputSetado
              emprendimentoValue={produto}
              empreendimentoSelectedValue={pull_data_empreendimento}
            />
          </>
        );
      case "Agendou Visita":
        return (
          <>
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
            <IC.NovaTarefaForm
              dataProgramadaValue={datatask.dataProgramadaRealizacaoTarefa}
              functionDataChange={(newValue: any) => handleChangeData(newValue)}
              horaProgramadaValue={datatask.horaProgramadaRealizacaoTarefa}
              functionHoraChange={(newValue: any) => handleChangeHora(newValue)}
              functionDescricaoChange={(e: any) =>
                handleTransferDescription(e.target.value)
              }
              descricaoValue={datatask.descricao}
              count={datatask.descricao?.length || 0}
              checkValue={datatask.inserirTarefaNoOutlook}
              functionCheckChange={() =>
                setDataTask({
                  ...datatask,
                  inserirTarefaNoOutlook: !datatask.inserirTarefaNoOutlook,
                })
              }
              produtoInput
              produtoInputSetado={false}
              functionEmpreendimentoChange={() =>
                setDataTask({
                  ...datatask,
                  idEmpreendimento: empreendimentoSelected?.value,
                })
              }
              empreendimentoSelectedValue={pull_data_empreendimento}
            />
          </>
        );
      case "Desqualificar":
        return (
          <>
            <IC.DesqualificarForm desqualificarId={pull_data} isLeadScreen />
            <IC.DefaultForm
              functionComment={(e: any) =>
                handleTransferComment(e.target.value)
              }
              count={datatask.observacoes.length}
              value={datatask.observacoes}
              valueFile={pull_file}
              valueFileBased={pull_file_based}
              functionFile={(e: any) => handleTransferFile(e.target.value)}
            />
          </>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    setDataTask({ ...datatask, idTipoTarefa: concludeSelected?.id });
  }, [datatask?.titulo]);

  useEffect(() => {
    setDataTask({
      ...datatask,
      idEmpreendimento: empreendimentoSelected?.value,
    });
  }, [empreendimentoSelected]);

  // Atualiza os motivos de atendimento quando o tipo de visita/retorno mudar
  useEffect(() => {
    setMotivoAtendimento(null);
    refetchMotivosAtendimento();
  }, [tipoVisitaRetorno]);

  const concludeNewTask = async (e: React.FormEvent) => {
    e.preventDefault();
    const dataNewTask = () => {
      if (
        datatask.dataProgramadaRealizacaoTarefa &&
        datatask.horaProgramadaRealizacaoTarefa
      ) {
        const formatedData = format(
          datatask?.dataProgramadaRealizacaoTarefa,
          "yyyy-MM-dd"
        );
        const formatedHora = format(
          datatask?.horaProgramadaRealizacaoTarefa,
          "HH:mm"
        );
        const dataNewTaskData = {
          dataProgramadaRealizacaoTarefa: formatedData,
          horaProgramadaRealizacaoTarefa: formatedHora,
          tokenAd: tokenAD,
        };
        return {
          dataNewTaskData,
        };
      }
      return undefined;
    };
    const data = () => {
      switch (concludeSelected?.nome) {
        case "Acompanhamento":
        case "Atendimento Não Realizado":
        case "Não Conseguiu Contato":
        case "Em Contato Com Outro Corretor":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
          };
        case "Atendimento Realizado":
          if (isSul) {
            return {
              idTipoResultadoTarefa: concludeSelected?.id,
              observacoes: datatask.observacoes,
              anexo: { nome: file, anexoBase64: fileData },
              codigoTipoAgendamentoVisita: tipoVisitaRetorno,
              motivoVisita: motivoAtendimento?.nome || datatask.motivoVisita,
              especialistaAcompanhou:
                corretorParceiro?.nome || datatask.especialistaAcompanhou,
              objetivoCompra: objetivoCompra?.nome || datatask.objetivoCompra,
              profissao: profissaoSelecionada?.nome || datatask.profissao,
              bairroResidencial: datatask.bairroResidencial,
              idade: datatask.idade,
              temperatura: temperatura?.nome || datatask.temperatura,
            };
          }
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
          };

        case "Retornar Contato":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
            descricao: datatask.descricao,
            inserirTarefaNoOutlook: datatask.inserirTarefaNoOutlook,
            idTipoTarefa: concludeSelected?.id,
            titulo: `Retornar contato ao ${nomeLead}`,
            idLead,
            idLeadCorretor,
            ...dataNewTask()?.dataNewTaskData,
          };
        case "Precisa Vender Imóvel":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
            descricao: datatask.descricao,
            inserirTarefaNoOutlook: datatask.inserirTarefaNoOutlook,
            idTipoTarefa: concludeSelected?.id,
            titulo: `${nomeLead} precisa vender o Imóvel`,
            idLead,
            idLeadCorretor,
            ...dataNewTask()?.dataNewTaskData,
          };
        case "Agendou Visita":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
            descricao: datatask.descricao,
            inserirTarefaNoOutlook: datatask.inserirTarefaNoOutlook,
            idTipoTarefa: concludeSelected?.id,
            // "10b2291d-5dd0-ec11-a7b5-00224836209c"
            titulo: `Visita agendada para ${nomeLead}`,
            idLead,
            idLeadCorretor,
            idEmpreendimento: empreendimentoSelected?.value,
            ...dataNewTask()?.dataNewTaskData,
          };
        case "Remarcou":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
            descricao: datatask.descricao,
            inserirTarefaNoOutlook: datatask.inserirTarefaNoOutlook,
            idEmpreendimento: empreendimentoSelected?.value,
            idTipoTarefa: concludeSelected?.id,
            titulo: `Visita remarcada para ${nomeLead}`,
            idLead,
            idLeadCorretor,
            ...dataNewTask()?.dataNewTaskData,
          };

        case "Desqualificar":
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
            idMotivoDesqualificacaoLead: desqualificarIdData,
          };
        default:
          return {
            idTipoResultadoTarefa: concludeSelected?.id,
            observacoes: datatask.observacoes,
            anexo: { nome: file, anexoBase64: fileData },
          };
      }
    };
    setLoading(true);

    try {
      await axiosLead.EditConcluirTask(datatask?.idTarefaLead, data());
      toast.success("Tarefa Concluida com sucesso.");
      onClose(!open);
      hotRefreshFunc();
      if (concludeSelected?.nome === "Desqualificar") {
        window.location.href = "/transferencia-concluida/desqualificado";
      }
    } catch (error: any) {
      warn.wargingError(
        `${
          error?.response?.data?.notifications?.map((item: any) => {
            if (item.key === "IdTipoResultadoTarefaSistemaOrigem") {
              return `Resultado é obrigatório`;
            }
            return `${item.message}\n`;
          }) || "Erro Genérico"
        }`
      );
    }

    setLoading(false);
  };

  const requestConclusaoTarefasData = async (idTipoResultadoTarefa: string) => {
    try {
      const response = await axiosLead.GetConclusaoTarefas(
        idTipoResultadoTarefa
      );
      setConclusaoTarefasData(response.data.data);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    refetchEmpreedimentos2();
    refetchEmpreendimentosSul();
    refetchProfissoes();
    refetchMotivosAtendimento();
    refetchObjetivosCompras();
    refetchTemperaturasLead();
    refetchCorretorParceiro();
    requestConclusaoTarefasData(datatask?.idTipoResultadoTarefa);
  }, []);

  useEffect(() => {
    const objectLenght = Object.keys(concludeSelected).length;
    if (objectLenght < 3) {
      setConcludeSelected({ nome: "Selecione um resultado", id: "1" });
    }
  }, []);

  useEffect(() => {
    if (concludeSelected === null) {
      setConcludeSelected({ nome: "Selecione um resultado", id: "1" });
    }
  }, [concludeSelected]);

  // Função para renderizar a opção de agenda baseada nas regras do SUL
  const renderAgendaOption = () => {
    // Quando tipoVisitaRetorno é 1, não exibe nada
    if (tipoVisitaRetorno === 1) {
      return null;
    }

    // Quando tipoVisitaRetorno é Retorno/Videochamada e não é data futura, não exibe nada
    if (tipoVisitaRetorno !== 1 && !isFutureDate) {
      return null;
    }

    // Nos outros casos, exibe a opção de agenda
    return (
      <Styles.RowGap>
        <Styles.RowGap>
          <Styles.FormControlLabel
            control={
              <Styles.Checkbox
                defaultChecked
                checked={datatask.inserirTarefaNoOutlook}
                onChange={() =>
                  setDataTask({
                    ...datatask,
                    inserirTarefaNoOutlook: !datatask.inserirTarefaNoOutlook,
                  })
                }
              />
            }
            label="Criar compromisso na agenda"
          />
        </Styles.RowGap>
      </Styles.RowGap>
    );
  };

  return (
    <Styles.ScrollContent maxHeight={600}>
      <form onSubmit={(e) => concludeNewTask(e)}>
        <Styles.FormComponent>
          <Styles.TransferComponent style={{ minHeight: 0, marginTop: 32 }}>
            <Styles.LabelText>
              Resultado *
              <FlagLeadAtt />
            </Styles.LabelText>
            <Styles.Autocomplete
              id="combo-box-demo"
              options={conclusaoTarefasData}
              value={concludeSelected}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Resultado *"
                    required
                  />
                </>
              )}
              renderOption={(option) => <CustomOption option={option} />}
              getOptionSelected={(option: any) => option.nome || ""}
              getOptionLabel={(option: any) => option.nome || ""}
              onChange={(event, newValue: any) => {
                setConcludeSelected(newValue);
              }}
            />
          </Styles.TransferComponent>
          {FormPersonalizado()}
          {/* Opção de agenda com base nas regras do SUL */}
          {isSul &&
            concludeSelected?.nome === "Atendimento Realizado" &&
            renderAgendaOption()}
        </Styles.FormComponent>
        <Styles.Footer>
          <Styles.FooterDialog>
            <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
              Cancelar
            </Styles.Button>
            <Styles.Button
              className="transfer-btn"
              color="secondary"
              variant="contained"
              type="submit"
              disabled={loading}
            >
              {loading ? <MaterialUI.CircularProgress /> : "Salvar"}
            </Styles.Button>
          </Styles.FooterDialog>
        </Styles.Footer>
      </form>
    </Styles.ScrollContent>
  );
};

export default ConcludeTaskForm;
